import React from 'react';
import { toast } from 'react-toastify';

import services from 'api/services';
import DownloadPdfReportToast from 'components/Toasts/DownloadReportToast';
const { TicketService } = services;

export const downloadReport = async (
  id,
  candidateName = 'Candidate',
  testName,
  type,
  anonymise,
  includeDescription,
  isAnonymiseLinkReport
) => {
  let link;
  try {
    toast.success(<DownloadPdfReportToast />);
    const downloadPdfData = isAnonymiseLinkReport
      ? await TicketService.downloadAnonymisePdfReport(id, type, includeDescription)
      : await TicketService.downloadPdfReport(id, type, anonymise, includeDescription);

    let fileName = (candidateName + '-' + testName)
      .replace(/\s+/g, '-') // If space replace with dash
      .replace(/[^\w\-.]/g, ''); // If not word, number, dash, or dot, then remove
    if (anonymise) fileName = 'User';
    if (type === 'complete') fileName += '_Complete_Report';
    else fileName += '_Candidate_Report';

    link = document.createElement('a');
    link.href = `data:application/pdf;base64,${downloadPdfData}`;
    link.download = `${fileName}.pdf`;
    link.click();
  } catch (e) {
    toast.error(typeof e === 'string' ? e : e?.message || 'Error Downloading report');
  } finally {
    link?.remove?.();
  }
};
